import React from 'react';
import { ContentText, ContentTextProps } from '@plugsurfing/elemental-ui';

export interface TextProps extends ContentTextProps {
  children?: string;
}

export const Text = React.memo((props: TextProps) => <ContentText size="m" marginVertical="1em" {...props} />);
